import { useEffect, useState } from 'react';

import { t } from '../i18n';

const STORAGE_KEY = 'noti.cookie-notice';

/**
 * The cookie notice. Noti sets no tracking cookies, so there is nothing to
 * refuse: the notice says so and points at the privacy statement. It is
 * shown once per browser.
 */
export function CookieNotice(): React.ReactElement | null {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (window.localStorage.getItem(STORAGE_KEY)) return;
    } catch {
      // A browser without storage shows the notice again next time.
    }
    setVisible(true);
  }, []);

  if (!visible) return null;

  return (
    <div className="cookies" role="region" aria-label={t('cookies.banner.title')}>
      <div className="cookies__text">
        <strong className="cookies__title">{t('cookies.banner.title')}</strong>
        <span>{t('cookies.banner.body')}</span>
        <a className="cookies__more" href="#legal/privacy">
          {t('cookies.banner.more')}
        </a>
      </div>
      <button
        type="button"
        className="btn-prim nb"
        onClick={() => {
          try {
            window.localStorage.setItem(STORAGE_KEY, '1');
          } catch {
            // Nothing to remember it with; the notice shows again next time.
          }
          setVisible(false);
        }}
      >
        {t('cookies.banner.accept')}
      </button>
    </div>
  );
}
